import type { RemoteTask, TaskStatus } from '@spacecode/shared/remote';

/** Input shape for `buildRemoteTask`. */
export interface RemoteTaskInput {
  id: string;
  repo: string;
  prompt: string;
  mode: RemoteTask['mode'];
  status: TaskStatus;
  exitCode?: number;
  branch?: string;
  error?: string;
  groupId?: string;
  prUrl?: string;
}

/**
 * Build a sandbox-backed RemoteTask record. Fixed sandbox fields are set here;
 * optional fields are only present when defined.
 * (Initial draft generated by Codemind build 82d40527; `as any` casts removed.)
 */
export function buildRemoteTask(input: RemoteTaskInput): RemoteTask {
  const now = new Date().toISOString();
  const task: RemoteTask = {
    id: input.id,
    machineId: 'sandbox',
    machineName: 'sandbox',
    repo: input.repo,
    prompt: input.prompt,
    mode: input.mode,
    status: input.status,
    region: 'auto',
    size: 'sandbox',
    createdAt: now,
    completedAt: now,
  };
  if (input.exitCode !== undefined) task.exitCode = input.exitCode;
  if (input.branch !== undefined) task.branch = input.branch;
  if (input.error !== undefined) task.error = input.error;
  if (input.groupId !== undefined) task.groupId = input.groupId;
  if (input.prUrl !== undefined) task.prUrl = input.prUrl;
  return task;
}

/** 'completed' on success, otherwise 'failed'. */
export function statusFromResult(success: boolean): 'completed' | 'failed' {
  return success ? 'completed' : 'failed';
}

/** 'cancelled' when aborted, otherwise 'failed'. */
export function errorTaskStatus(isAbort: boolean): 'cancelled' | 'failed' {
  return isAbort ? 'cancelled' : 'failed';
}
